export class HandoverStatusNotice {
    constructor() {
        this.type = "handoverStatus";
    }
}
